/* eslint-disable sort-keys-fix/sort-keys-fix */
import { createTheme } from "@mui/material";
export const theme = createTheme({
  breakpoints: {
    values: {
      mobile: 0,
      tablet: 768,
      desktop: 1024,
      homeDesktop: 1070,
      mediumDesktop: 1280,
      largeDesktop: 1440,
      xLargeDesktop: 1560
    }
  }
});